import React from 'react';
import { Database, Globe, Terminal, Brain } from 'lucide-react';

const Skills = () => {
  const skillCategories = [
    {
      title: "Frontend Development",
      icon: <Globe className="w-6 h-6" />,
      color: "bg-blue-500",
      skills: [
        { name: "React", level: 90 },
        { name: "TypeScript", level: 85 },
        { name: "Next.js", level: 80 },
        { name: "Tailwind CSS", level: 95 },
        { name: "Redux/Context API", level: 85 },
        { name: "HTML5/CSS3", level: 95 }
      ],
    },
    {
      title: "Backend Development",
      icon: <Database className="w-6 h-6" />,
      color: "bg-green-500",
      skills: [
        { name: "Python", level: 90 },
        { name: "Node.js", level: 85 },
        { name: "FastAPI", level: 85 },
        { name: "PostgreSQL", level: 80 },
        { name: "MongoDB", level: 85 },
        { name: "Express.js", level: 85 },
        { name: "Java", level: 60 }
      ],
    },
    {
      title: "Core AI Skills",
      icon: <Brain className="w-6 h-6" />,
      color: "bg-purple-500",
      skills: [
        { name: "LLM Orchestration", level: 85 },
        { name: "Langchain", level: 80 },
        { name: "RAG Pipelines", level: 85 },
        { name: "Prompt Engineering", level: 90 },
        { name: "Vector Databases", level: 80 },
        { name: "Agent Frameworks", level: 85 },
      ],
    },
    {
      title: "Tools & DevOps",
      icon: <Terminal className="w-6 h-6" />,
      color: "bg-pink-500",
      skills: [
        { name: "Git/GitHub", level: 90 },
        { name: "Docker", level: 80 },
        { name: "AWS", level: 75 },
        { name: "Vercel/Netlify", level: 90 },
        { name: "Linux", level: 80 },
      ],
    }
  ];

  return (
    <div className="max-w-7xl mx-auto p-8 font-sans">
      {/* Header */}
      <div className="mb-12 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4 tracking-tight">
          Skills & Expertise
        </h1>
        <p className="text-lg text-gray-500 max-w-2xl mx-auto">
          Technologies and tools I work with to build amazing products.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {skillCategories.map((category, index) => (
          <div 
            key={index} 
            className="glass rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300"
          >
            {/* Category Header */}
            <div className="p-6 flex items-center gap-4 border-b border-gray-100 bg-gray-50/50">
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl bg-white shadow-sm text-gray-900`}>
                {category.icon}
              </div>
              <h2 className="text-xl font-bold text-gray-900">{category.title}</h2>
            </div>
            
            {/* Skills List */}
            <div className="p-6 space-y-5">
              {category.skills.map((skill, idx) => (
                <div key={idx}>
                  <div className="flex justify-between mb-2">
                    <span className="font-medium text-gray-700 text-sm">{skill.name}</span>
                    <span className="font-mono text-xs font-semibold text-gray-500">{skill.level}%</span>
                  </div>
                  <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden">
                    <div 
                      className={`${category.color} h-full rounded-full transition-all duration-1000 ease-out`}
                      style={{ width: `${skill.level}%` }}
                    >
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            {/* Footer badge */}
            <div className="px-6 pb-6 flex justify-between items-center bg-gray-50/30">
              <div className="text-xs font-mono text-gray-400">
                CATEGORY_{String(index + 1).padStart(2, '0')}
              </div>
              <div className="text-xs font-semibold text-gray-500 bg-gray-100 px-2 py-1 rounded">
                {category.skills.length} Techs
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;